// extracted by mini-css-extract-plugin
module.exports =  {"item":"Template36-Y72n__item"};